import React from "react";
import { Box } from "@mui/material";

export const TabPanel: React.FC<{
  children?: React.ReactNode;
  index: number;
  value: number;
}> = ({ children, value, index, ...other }) => {
  if (value !== index) return null;
  return (
    <div
      role="tabpanel"
      id={`applicant-tabpanel-${index}`}
      aria-labelledby={`applicant-tab-${index}`}
      {...other}
    >
      <Box sx={{ p: { xs: 0, md: 2 } }}>{children}</Box>
    </div>
  );
};

